import { useLobbyLanguages } from "@shared/hooks/lobby/lobby";
import { languageService, TLocale } from "@shared/services";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export const useLocaleList = (): { localeList: TLocale[] } => {
  const languages = useLobbyLanguages();
  const dispatch = useDispatch();
  const [localeList, setLocaleList] = useState<TLocale[]>(
    languageService.appAllowLanguageList(languages)
  );

  useEffect(() => {
    const locales = languageService.appAllowLanguageList(languages);
    setLocaleList(locales);
  }, [dispatch, languages]);
  return { localeList };
};
